module.exports = __webpack_public_path__ + "static/img/goods03.191c289e.jpg";